/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { TestRunDispatchResultCto } from '../../models/test-run-dispatch-result-cto';
import { TestRunRequestCto } from '../../models/test-run-request-cto';

export interface StartTestRun$Plain$Params {
      body?: TestRunRequestCto
}

export function startTestRun$Plain(http: HttpClient, rootUrl: string, params?: StartTestRun$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<TestRunDispatchResultCto>> {
  const rb = new RequestBuilder(rootUrl, startTestRun$Plain.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<TestRunDispatchResultCto>;
    })
  );
}

startTestRun$Plain.PATH = '/automatedtest/v1/cicd/selfserve';
